module.exports = __webpack_public_path__ + "img/dogTags_TH copy.c405cf78.png";